import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import Box from "@mui/material/Box";

export const AppSlider = ({ images }: { images: Array<string> }) => {
    return (
        <Carousel showStatus={false} autoPlay={true} interval={15000} showThumbs={false} dynamicHeight={true} infiniteLoop>
            {images && images.map(image => (
                <Box key={Math.random()}>
                    {/*<img style={{ maxWidth: '698px', height: '368px',}} src={image} />*/}
                    {/*<div style={{background: `url(${image}) no-repeat scroll center top transparent`, height: '368px'}} />*/}
                    {/*{TODO: Better image sizing fix?}*/}
                    {/*<div style={{background: `url(${image}) no-repeat scroll center top transparent`, height: '368px', backgroundSize: 'auto 100%'}} />*/}
                    <Box sx={{background: `url(${image}) no-repeat scroll center top transparent`, height: {md: '368px', xs: '200px'}, backgroundSize: 'auto 100%'}} />
                </Box>
            ))}
        </Carousel>
    )
}
